var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.02 20H29.98C29.4549 20 28.9513 20.2086 28.5799 20.5799C28.2086 20.9513 28 21.4549 28 21.98V27C28 27.2652 27.8946 27.5196 27.7071 27.7071C27.5196 27.8946 27.2652 28 27 28H5C4.73478 28 4.48043 27.8946 4.29289 27.7071C4.10536 27.5196 4 27.2652 4 27V5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H14.02C14.5451 4 15.0487 3.79139 15.4201 3.42007C15.7914 3.04875 16 2.54513 16 2.02V1.98C16 1.45487 15.7914 0.951251 15.4201 0.579929C15.0487 0.208607 14.5451 0 14.02 0H1.98C1.45487 0 0.951251 0.208607 0.579929 0.579929C0.208607 0.951251 0 1.45487 0 1.98L0 30.02C0 30.5451 0.208607 31.0487 0.579929 31.4201C0.951251 31.7914 1.45487 32 1.98 32H30.02C30.5451 32 31.0487 31.7914 31.4201 31.4201C31.7914 31.0487 32 30.5451 32 30.02L31.98 30H32V21.98C32 21.4549 31.7914 20.9513 31.4201 20.5799C31.0487 20.2086 30.5451 20 30.02 20Z",
    fill: "url(#paint0_linear_1_14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.944 5.71201C19.265 6.11701 14.894 7.98101 11.931 11.273C9.62661 13.8666 8.2639 17.1614 8.063 20.625C8.02981 20.922 8.05963 21.2226 8.1505 21.5073C8.24138 21.7919 8.39127 22.0542 8.59039 22.277C8.78951 22.4998 9.03338 22.6781 9.30608 22.8003C9.57878 22.9225 9.87418 22.9857 10.173 22.986L10.273 22.976C10.7281 22.9262 11.1512 22.7177 11.4679 22.3871C11.7847 22.0565 11.9748 21.6249 12.005 21.168C12.1578 18.4945 13.1872 15.9457 14.934 13.916C17.141 11.484 20.527 10.086 25 9.72601V10H24.944L24.901 10.268L22.596 12.595C22.2237 12.9724 22.0149 13.4813 22.0149 14.0115C22.0149 14.5417 22.2237 15.0506 22.596 15.428C22.7793 15.614 22.9977 15.7616 23.2386 15.8624C23.4794 15.9632 23.7379 16.0151 23.999 16.0151C24.2601 16.0151 24.5186 15.9632 24.7594 15.8624C25.0003 15.7616 25.2187 15.614 25.402 15.428L31.418 9.35401C31.7906 8.97652 31.9996 8.46744 31.9996 7.93701C31.9996 7.40657 31.7906 6.89749 31.418 6.52001L25.418 0.587007C25.2347 0.401213 25.0164 0.253684 24.7756 0.15299C24.5348 0.0522956 24.2765 0.000442505 24.0155 0.000442505C23.7545 0.000442505 23.4962 0.0522956 23.2554 0.15299C23.0146 0.253684 22.7963 0.401213 22.613 0.587007C22.2401 0.964366 22.031 1.4735 22.031 2.00401C22.031 2.53452 22.2401 3.04365 22.613 3.42101L24.944 5.71201Z",
    fill: "url(#paint1_linear_1_14)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_14",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FD84F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#699D67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_14",
    x1: 20.0247,
    y1: 0.000442505,
    x2: 20.0247,
    y2: 22.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FD84F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#699D67"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export-icon.1d017ad29e0d712207a7e0994c6d5f5a.svg";
export { ForwardRef as ReactComponent };